import styles from '@stylesheet';
import { Text, View, Pressable } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { Title } from '@constants/Themed';
import LottieView from '@utils/lottieAnimation';
import { BlankTrophy } from '@assets/--native';
import { useLottieAnim } from '@hooks/lottieHook';
import React from 'react';

const CompanyAchievementList = ({ achievementData, achievementPoints, navigation }) => {
  const achievementsHistory = [1, 2, 3, 4, 5];
  const animation = useLottieAnim();
  return (
    <View style={[styles.noteContainer, { flex: 1, backgroundColor: '#eeeeee', padding: 15, alignItems: 'flex-start', flexWrap: 'nowrap', overflow: 'hidden', padding: 20 }]}>
      <View style={{ flexDirection: 'row', padding: 30 }}>
        <Pressable style={{ flex: .7, alignContent: 'flex-start' }} onPress={() => { navigation.push('Settings', { screen: 'Achievements' }) }}>
          <LottieView ref={animation} style={{ width: '100%', flex: 1, marginLeft: -30, alignSelf: 'flex-start', justifyContent: 'flex-start' }} source={require('@assets/animations/achievementTrophy.json')} autoPlay loop={false} />
        </Pressable>
        <View style={{ flexDirection: 'column', flex: 1, alignItems: 'flex-end' }}>
          <View style={{ flex: 1 }}></View>
          <View style={{ flex: 4 }}>
            <Text adjustsFontSizeToFit style={{ fontSize: 20 }}><Title style={{ fontSize: 50 }}>{achievementPoints}</Title>pts</Text>
          </View>
          <View style={{ flex: 1 }}></View>
          <View style={{ flexDirection: 'row' }}>
            {
              achievementsHistory.map((achievements, k) => {
                return (
                  <View style={{ flex: 1, flexDirection: 'row' }} key={k}>
                    <Pressable style={{ flex: 1, flexDirection: 'row', zIndex: k - 10, marginTop: -10 }} >
                      {/* <BlankTrophy style={{ flex: 1, width: '100%', height: '100%', alignSelf: 'center' }} /> */}
                      <View style={{ flex: .5 }} />
                    </Pressable>
                  </View>
                )
              })
            }
          </View>
        </View>
      </View>
      <Text adjustsFontSizeToFit >Extended Contextual Statistics on Business Performance, e.g. you sold xx products this week?</Text>
      <View style={{ flex: 0.1 }} />
      <Text adjustsFontSizeToFit >Achievement suggestion based output</Text>
      <Text adjustsFontSizeToFit >Map users and current achievements related to this company here!</Text>
    </View >
  )
}
export default CompanyAchievementList;